<template>
  <div class="plan-details">
    <header style="background: #CBD63E">
      <strong>{{ plan.name }}</strong>
    </header>

    <main class="mt-2; mx-2" style="text-align: center;" v-if="namePlan === 'MO1HO'">
      <strong>Total a pagar:</strong>
      <strong class="total-pay" v-if="discount">{{formatRealCurrent(priceForPromotion)}}</strong>
      <strong class="total-pay" v-else>{{formatRealCurrent(finalPrice)}}</strong>
    </main>

    <main v-else class="mt-2; mx-2" style="text-align: center;" >
      <span>
          <i>Todas as funcionalidades do software HO Fácil Web sem nenhuma limitação.</i>
      </span>
      <div v-if="billingData.contractTimeYears && billingData.contractTimeYears > 0">
        <h6 class="mt-3"><strong>Detalhes da sua compra:</strong></h6>

        <ul style="list-style-position: inside">
          <li>
                <span>Usuário master: 1 un. de
                  <span>{{ billingData.contractTimeYears }} {{ billingData.contractTimeYears > 1 ? 'anos' : 'ano' }} de acesso por </span>
                  <span v-if="discount" style="text-decoration: line-through; color:#bc0000;">{{ formatRealCurrent(parseFloat(getPlan.value) * billingData.contractTimeYears)}}</span>
                  <span v-if="discount">&nbsp;&nbsp;</span>
                  <span>{{ formatRealCurrent((parseFloat(getPlan.value) - parseFloat(getDiscount)) * billingData.contractTimeYears)}}</span>
                </span>
          </li>
          <li v-if="billingData.precoCompraUsuariosSubordinados > 0">
              <span >
                Usuário(s) subordinado(s):
                {{billingData.numberAccesses}}
                un. de
                <span>{{ billingData.contractTimeYears }} {{ billingData.contractTimeYears > 1 ? 'anos' : 'ano' }} de acesso por </span>
                {{formatRealCurrent(parseFloat(billingData.precoCompraUsuariosSubordinados))}}
              </span>
          </li>
        </ul>
        <div v-if="installments && (installments == 2 || installments == 3)">
          <span >
            Foi escolhida a opção de parcelamento no cartão de crédito em {{installments}} vezes:
          </span><br/><br/>

          <p>
            <strong>Total a pagar:</strong><br/>
            <strong class="total-pay" v-if="discount">{{formatRealCurrent(priceForPromotion)}}</strong>
            <strong class="total-pay" v-else>{{formatRealCurrent(finalPrice)}}</strong>

            <span>
              <br/><strong>sendo</strong><br/>
              <strong class="total-pay">{{installments}} x
                <span v-if="discount">{{ formatRealCurrent(priceForPromotion / installments) }}</span>
                <span v-else>{{ formatRealCurrent(finalPrice / installments) }}</span>
              </strong>
            </span>
          </p>
        </div>

        <div v-else-if="installments && installments > 3">
          <p >
            Foi escolhida a opção de parcelamento no cartão de crédito em {{installments}} vezes.
            Por isso, o valor total abaixo já inclui os juros do parcelamento.
          </p>

          <p>
            <strong>Total a pagar:</strong><br/>
            <strong class="total-pay" v-if="discount">{{formatRealCurrent(priceForPromotion)}}</strong>
            <strong class="total-pay" v-else>{{formatRealCurrent(finalPrice)}}</strong>

            <span>
              <br/><strong>sendo</strong><br/>
              <strong class="total-pay">{{installments}} x
                <span v-if="discount">{{ formatRealCurrent(priceForPromotion/ installments) }}</span>
                <span v-else>{{ formatRealCurrent(finalPrice / installments) }}</span>
              </strong>
            </span>
          </p>
        </div>

        <div v-else>
          <p>
            <strong>Total a pagar:</strong><br/>
            <strong class="total-pay" v-if="discount">{{formatRealCurrent(priceForPromotion)}}</strong>
            <strong class="total-pay" v-else>{{formatRealCurrent(finalPrice)}}</strong>
          </p>
        </div>
      </div>

      <div class="mt-2" v-else>
        <p>
          <span>
            Preço visível após selecionar quantidade de usuários e tempo de acesso.
          </span>
        </p>
      </div>
    </main>


    <footer>
      <span class="title"> Métodos de pagamento aceitos: </span>
      <div class="payment-flags">
        <img v-if="!payment.method || payment.method == 'bank_slip'" alt="Boleto" src="../../../assets/images/pagamento/boleto.svg" />
        <img v-if="!payment.method || payment.method == 'bank_slip'" class='mb-1 mx-1' style='box-shadow: rgba(100, 100, 111, 0.2) 1px 2px 2px 1px; padding: 2px 5px; border-radius: 3px' width="56" height="36" alt='PIX' src='../../../assets/images/pagamento/pix.svg' />
        <img v-if="!payment.method || payment.method == 'credit_card'" alt="Amex" src="../../../assets/images/pagamento/amex.svg" />
        <img v-if="!payment.method || payment.method == 'credit_card'" alt="Dinner`s club" src="../../../assets/images/pagamento/dinners.svg"/>
        <img v-if="!payment.method || payment.method == 'credit_card'" alt="ELO" src="../../../assets/images/pagamento/elo.svg" />
        <img v-if="!payment.method || payment.method == 'credit_card'" alt="Mastercard" src="../../../assets/images/pagamento/master.svg"/>
        <img v-if="!payment.method || payment.method == 'credit_card'" alt="Visa" src="../../../assets/images/pagamento/visa.svg" />
      </div>
      <span class="by">
        Ambiente e transações 100% seguros por
        <a href="https://iugu.com" target="_blank">iugu</a>
      </span>
    </footer>
  </div>
</template>

<script>
//import Countdown from "./Countdown"
import { formatRealCurrent } from '@/utils/format'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PlanDetails',
  props: {
    namePlan: { type: String, required: true },
    plans: { type: Object, required: true },
    code: { type: String },
    installments: { type: Number, required: true },
    discount: { type: Number, required: true },
  },
  components: {
    /*Countdown*/
  },
  data() {
    return {
      counterLegend: '',
      counterDate: null,
      plan: {},
      promotionPlans: ['PROMO', 'PROMO2'],
      promotionNotStarted: false,
      taxaJuros: 1.49,
    }
  },
  computed: {
    ...mapGetters('checkout2', {
      promotion: 'getPromotion',
      billingData: 'getBillingData',
      payment: 'getPayment',
      getPlan: 'getPlan',
      getDiscount: 'getDiscount'
    }),
    user() {
      return this.$store.getters['user/current']
    },
    priceForPromotion() {
      let discount = this.discount
      if (this.promotion && this.promotion.code === 'RENEW' && this.discount) {
        discount = (parseFloat(discount) *  parseFloat(this.plan.value)) / 100
      }
      this.handleSetdiscount(discount)
      this.calculateTotalPlan()
      if (this.installments <= 3) {
        return ((parseFloat(this.plan.value) - discount) * parseInt(this.billingData.contractTimeYears)) + Number(this.billingData.precoCompraUsuariosSubordinados)
      } else {
        if (!discount) {
          discount = 0
        }
        const priceTotal = (((parseFloat(this.plan.value) - parseFloat(discount)) * parseInt(this.billingData.contractTimeYears)) + Number(this.billingData.precoCompraUsuariosSubordinados)) * Math.pow(1 + this.taxaJuros / 100, this.installments)
        return priceTotal
      }
    },
    finalPrice() {
      let discount = this.discount
      if (this.promotion && this.promotion.code === 'RENEW' && this.discount) {
        discount = (Number(discount) *  Number(this.plan.value)) / 100
      }
      this.handleSetdiscount(discount)
      this.calculateTotalPlan()
      if (this.installments <= 3) {
        return (parseFloat(this.plan.value) * parseInt(this.billingData.contractTimeYears)) + Number(this.billingData.precoCompraUsuariosSubordinadosSemDesconto)
      } else {
        return ((parseFloat(this.plan.value) * parseInt(this.billingData.contractTimeYears)) + Number(this.billingData.precoCompraUsuariosSubordinadosSemDesconto)) * Math.pow(1 + this.taxaJuros / 100, this.installments)
      }
    },
  },
  methods: {
    ...mapActions('checkout2', {
      handleSetdiscount: 'handleSetdiscount',
      calculateTotalPlan: 'calculateTotalPlan',
    }),
    formatRealCurrent,
    planIsPromotion(namePlan) {
      const exists = this.promotionPlans.find((plan) => plan === namePlan)

      return exists ? true : false
    },
    init(){
      if (this.namePlan) {
        this.plan = this.plans[this.namePlan]

        if (this.planIsPromotion(this.namePlan)) {
          const today = new Date(this.plan.today)
          const validFrom = new Date(this.plan.validFrom)
          const validUntil = new Date(this.plan.validUntil)
          if (today.getTime() <= validFrom.getTime()) {
            this.counterLegend = 'Promoção começa em:'
            this.counterDate = this.plan.validFrom
            this.$emit('block-plan')
          } else if (
            today.getTime() >= validFrom.getTime() &&
            today.getTime() <= validUntil.getTime()
          ) {
            this.counterLegend = 'Promoção termina em:'
            this.counterDate = this.plan.validUntil
            this.$emit('block-plan')
          }
        }
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
      plans() {
        this.init()
      },
  },
}
</script>

<style lang="scss" scoped>
.plan-details {
  max-width: 330px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 8px;

  background: var(--white);

  @media only screen and (max-width: 720px) {
    max-width: 100%;
  }

  header {
    text-align: center;
    padding: 8px 0;

    border-bottom: 1px solid #999999;

    span {
      font-size: 18px;
      font-weight: bold;
      color: #999999;
    }
  }
  main {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 8px;

    padding: 0 16px;

    font-size: 16px;

    .description {
      font-style: italic;
    }

    .price,
    .price-discount {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 32px;
      font-weight: bold;
      text-align: center;

      span.discount {
        text-decoration: line-through;
      }

      .subtitle {
        font-size: 12px;
      }
    }

    .countdown-container {
      span {
        font-size: 18px;
        font-weight: 700;
      }
    }
    .total-pay{
      font-size: 26px;
      font-weight: bold;
    }
  }
  footer {
    padding: 0 16px 16px;

    .title,
    .by {
      font-size: 10px;
    }
    .payment-flags {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
</style>
